module.exports = __webpack_public_path__ + "img/hcdl_gallery5.345bce84.jpg";